import { MessageParams } from "../entities/addMessageSocket";
import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class AddMessage {
	constructor(private repository: ChatSocketRepository) {}

	execute(params: AddMessageParams): Promise<void> {
		return this.repository.addMessage(params.messageParams);
	}
}

export class AddMessageParams {
	constructor(public messageParams: MessageParams) {}
}
